import type { MapId } from "@rivalwatch/shared";
import { BRUSSELS } from "./brussels/index.ts";
import { DEFAULT_LOOK } from "./default.ts";
import { ORLANDO } from "./orlando/index.ts";
import type { MapLook } from "./types.ts";

export const MAP_LOOKS: Record<MapId, MapLook> = {
  foundry: DEFAULT_LOOK,
  switchyard: DEFAULT_LOOK,
  brussels: BRUSSELS,
  orlando: ORLANDO,
};

export const lookOf = (id: MapId): MapLook => MAP_LOOKS[id] ?? DEFAULT_LOOK;
